import React, { Component } from 'react'
import axios from 'axios'
import moment from 'moment'
import { APIURL } from '../../../config/config'
import pdfMake from 'pdfmake/build/pdfmake'

class CarInAll extends Component{

  constructor (props) {
    super(props)
    this.state = {
      car_list: [],
      reserve_status: [7, 10, 12]
    }

    this.loadCarAll = this.loadCarAll.bind(this)
    this.printCarAll = this.printCarAll.bind(this)
    this.onChangeParkLocation = this.onChangeParkLocation.bind(this);
    this.onChangePlateRed = this.onChangePlateRed.bind(this);
    this.onChangeTunedCar = this.onChangeTunedCar.bind(this);
    this.onClickSave = this.onClickSave.bind(this);
  }

  componentDidMount() {
    this.loadCarAll();
  }

  loadCarAll() {
    var url = APIURL+'/car'
    axios.get(url).then(res => {

      var data = res.data.map(car => {
        return {...car, car_edit: 1}
      })
     var carData = data.sort((a, b) => {
        var dateA = new Date(a.car_date_in)
        var dateB = new Date(b.car_date_in)
        return (dateB.getTime() > dateA.getTime()) ? b : a
      })

      // console.log(carData)
     this.setState({car_list: carData});
    })
  }

  printCarAll() {

    // sum by การจอด park_location
    // หน้าเต็นท์
    var inFronts = this.state.car_list.filter(car => car.park_location === "สาขา 1" ).map((car, index) => {
        return car
    })
    var inBacks = this.state.car_list.filter(car => car.park_location === "สาขา 2" ).map((car, index) => {
      return car
    })
    var inAue = this.state.car_list.filter(car => car.park_location === "จอดอู่" ).map((car, index) => {
      return car
    })
    var inSaha = this.state.car_list.filter(car => car.park_location === "สหการประมูล" ).map((car, index) => {
      return car
    })
    var inApple = this.state.car_list.filter(car => car.park_location === "แอพเพิลการประมูล" ).map((car, index) => {
      return car
    })
    var inSakon = this.state.car_list.filter(car => car.park_location === "สากลการประมูล" ).map((car, index) => {
      return car
    })

    var inComing = this.state.car_list.filter(car => car.park_location === "กำลังมา" ).map((car, index) => {
      return car
    })

    var inCenter = this.state.car_list.filter(car => car.park_location === "จอดศูนย์" ).map((car, index) => {
      return car
    })

    /*var inฺฺBranch2 = this.state.car_list.filter(car => car.park_location === "สาขา 2" ).map((car, index) => {
      return car
    })*/

    //car.car_status_id===7
    var reserve_status = this.state.reserve_status
    var carReserve = this.state.car_list.filter(car => reserve_status.includes(car.car_status_id) ).map((car, index) => {
      return car
    })

    var widthTableSum = [120, 70, 30, 120, 70,30]
    var carSums = []

    var itemSumFronts = [
      {
        text: 'จอดสาขา 1',
        style: 'textBold',
        border: [false, false, false, false]
      },
      {
        text: inFronts.length,
        style: 'textCenterBoldRed',
        border: [false, false, false, false]
      },
      {
        text: 'คัน',
        style: 'textBold',
        border: [false, false, false, false]
      },
      {
        text: 'สหการประมูล',
        style: 'textBold',
        border: [false, false, false, false]
      },
      {
        text: inSaha.length,
        style: 'textCenterBoldRed',
        border: [false, false, false, false]
      },
      {
        text: 'คัน',
        style: 'textBold',
        border: [false, false, false, false]
      },
    ];
    // text: 'จอดหลังเต็นท์',
    var itemSumฺฺBacks = [
      {
        text: 'จอดสาขา 2',
        style: 'textBold',
        border: [false, false, false, false]
      },
      {
        text: inBacks.length,
        style: 'textCenterBoldRed',
        border: [false, false, false, false]
      },
      {
        text: 'คัน',
        style: 'textBold',
        border: [false, false, false, false]
      },
      {
        text: 'แอพเพิลการประมูล',
        style: 'textBold',
        border: [false, false, false, false]
      },
      {
        text: inApple.length,
        style: 'textCenterBoldRed',
        border: [false, false, false, false]
      },
      {
        text: 'คัน',
        style: 'textBold',
        border: [false, false, false, false]
      },
    ];
    var itemSumฺฺAue = [
      {
        text: 'จอดอู่',
        style: 'textBold',
        border: [false, false, false, false]
      },
      {
        text: inAue.length,
        style: 'textCenterBoldRed',
        border: [false, false, false, false]
      },
      {
        text: 'คัน',
        style: 'textBold',
        border: [false, false, false, false]
      },
      {
        text: 'สากลการประมูล',
        style: 'textBold',
        border: [false, false, false, false]
      },
      {
        text: inSakon.length,
        style: 'textCenterBoldRed',
        border: [false, false, false, false]
      },
      {
        text: 'คัน',
        style: 'textBold',
        border: [false, false, false, false]
      }
    ];

    var itemSumฺฺCenter = [
      {
        text: 'จอดศูนย์',
        style: 'textBold',
        border: [false, false, false, false]
      },
      {
        text: inCenter.length,
        style: 'textCenterBoldRed',
        border: [false, false, false, false]
      },
      {
        text: 'คัน',
        style: 'textBold',
        border: [false, false, false, false]
      },
      {
        text: '',
        style: 'textBold',
        border: [false, false, false, false]
      },
      {
        text: '',
        style: 'textCenterBoldRed',
        border: [false, false, false, false]
      },
      {
        text: '',
        style: 'textBold',
        border: [false, false, false, false]
      }

    ];

    /* var itemSumฺฺSaha = [
      {
        text: 'สหการประมูล',
        style: 'textBold',
        border: [false, false, false, false]
      },
      {
        text: inSaha.length,
        style: 'textCenterBoldRed',
        border: [false, false, false, false]
      },
      {
        text: 'คัน',
        style: 'textBold',
        border: [false, false, false, false]
      },
      {
        text: '',
        style: 'textBold',
        border: [false, false, false, false],
        colSpan: 3
      },
    ]; */

    /* var itemSumฺฺApple = [
      {
        text: 'แอพเพิลการประมูล',
        style: 'textBold',
        border: [false, false, false, false]
      },
      {
        text: inApple.length,
        style: 'textCenterBoldRed',
        border: [false, false, false, false]
      },
      {
        text: 'คัน',
        style: 'textBold',
        border: [false, false, false, false]
      },
      {
        text: '',
        style: 'textBold',
        border: [false, false, false, false],
        colSpan: 3
      },
    ]; */

    /* var itemSumฺฺSakon = [
      {
        text: 'สากลการประมูล',
        style: 'textBold',
        border: [false, false, false, false]
      },
      {
        text: inSakon.length,
        style: 'textCenterBoldRed',
        border: [false, false, false, false]
      },
      {
        text: 'คัน',
        style: 'textBold',
        border: [false, false, false, false]
      },
      {
        text: '',
        style: 'textBold',
        border: [false, false, false, false],
        colSpan: 3
      },
    ]; */


    var itemSumฺInComing = [
      {
        text: 'กำลังมา',
        style: 'textBold',
        border: [false, false, false, false]
      },
      {
        text: inComing.length,
        style: 'textCenterBoldRed',
        border: [false, false, false, false]
      },
      {
        text: 'คัน',
        style: 'textBold',
        border: [false, false, false, false]
      },
      {
        text: 'รถทั้งหมด',
        style: 'textBold',
        border: [false, false, false, false]
      },
      {
        text: this.state.car_list.length,
        style: 'textCenterBoldRed',
        border: [false, false, false, false]
      },
      {
        text: 'คัน',
        style: 'textBold',
        border: [false, false, false, false]
      },
    ];
    /* var itemSumฺAll = [
      {
        text: 'รถทั้งหมด',
        style: 'textBold',
        border: [false, false, false, false]
      },
      {
        text: this.state.car_list.length,
        style: 'textCenterBoldRed',
        border: [false, false, false, false]
      },
      {
        text: 'คัน',
        style: 'textBold',
        border: [false, false, false, false]
      },
      {
        text: '',
        style: 'textBold',
        border: [false, false, false, false],
        colSpan: 3
      },
    ]; */



    carSums.push(itemSumFronts)
    carSums.push(itemSumฺฺBacks)
    carSums.push(itemSumฺฺAue)
    carSums.push(itemSumฺฺCenter)
    // carSums.push(itemSumฺฺSaha)
    // carSums.push(itemSumฺฺApple)
    // carSums.push(itemSumฺฺSakon)

   // if (inComing.length > 0)
      carSums.push(itemSumฺInComing)

    // carSums.push(itemSumฺAll)

    var carAllRows = []
    var raito  = 100/6;
    var widthTable = [raito*0.5+'%', '*', raito*0.7+'%', raito*0.7+'%', raito*0.7+'%', raito*0.7+'%', raito*0.7+'%']
    var headerText = "ข้อมูลรถในเต็นท์ วันที่ "+moment(new Date()).local('TH').format('LLL')

    var carReserveSumPdf = [
      {
        text: '     รถจอง',
        style: 'textBoldRight',
        border: [false, false, false, false]
      },
      {
        text: carReserve.length,
        style: 'textCenterBoldRed',
        border: [false, false, false, false]
      },
      {
        text: 'คัน',
        style: 'textBold',
        border: [false, false, false, false]
      }
    ]

    var tableHeader = [
      { style: 'bodyBold', text: 'ลำดับ',},
      { style: 'bodyBold', text: 'ยี่ห้อ/รุ่น',},
      { style: 'bodyBold', text: 'ทะเบียน',},
      { style: 'bodyBold', text: 'ป้ายแดง',},
      { style: 'bodyBold', text: 'รถจอด',},
      { style: 'bodyBold', text: 'รถแต่ง',},
      { style: 'bodyBold', text: 'รถจอง',},
    ];

    carAllRows.push(tableHeader);

    this.state.car_list.forEach((car, index) => {
      var row = []
      var order = index + 1;
      //var date_in = moment(car.car_date_in).format('DD-MM-YYYY')
      var car_detail = car.car_name+' '+car.car_color_name
      var license = car.car_license_plate_new+'\n'+car.province_name_new
      var plate_red = car.plate_red
      var park_location = car.park_location
      var tuned_car = car.tuned_car
      var car_status_name = reserve_status.includes(car.car_status_id)? "จอง" : "-"

      var itemOrder = {
        text: order,
        style: 'textCenter'
      };
      var itemCarDetail = {
        text: car_detail,
        style: 'bodyText'
      };
      var itemLicense = {
        text: license,
        style: 'textCenter'
      }
      var itemPlateRed = {
        text: plate_red,
        style: 'textCenterRed'
      }
      var itemPark = {
        text: park_location,
        style: 'textCenter'
      }
      var itemTunedCar = {
        text: tuned_car,
        style: 'textCenter'
      }
      var itemCarStatusName = {
        text: car_status_name,
        style: 'textCenterRed'
      }

      row.push(itemOrder)
      row.push(itemCarDetail)
      row.push(itemLicense)
      row.push(itemPlateRed)
      row.push(itemPark)
      row.push(itemTunedCar)
      row.push(itemCarStatusName)
      //
      carAllRows.push(row)
    });

    var docDefinition = {
      pageOrientation: 'portrait',
      pageSize: 'A4',
      pageMargins: [45, 30, 45, 30], // margin: [left, top, right, bottom]
      content: [
        {text: headerText, style: 'bodyHead', lineHeight: 1.3},
        {
          table: {
          widths: ['33%','33%','33%'],
          body: [carReserveSumPdf]
          }
        },
        {
          table: {
            widths: widthTableSum,
            body: carSums
          }
        },
        {
          table: {
            headerRows: 1,
            widths: widthTable,
            body: carAllRows
          }
        },
      ],
      styles: {
        bodyHead: {
          fontSize: 20,
          bold: true,
          alignment: 'center'
        },
        bodyText: {
          fontSize: 14,
        },
        bodyBold: {
          fontSize: 14,
          bold: true,
          alignment: 'center'
        },
        textCenter: {
          fontSize: 14,
          alignment: 'center'
        },
        textCenterRed: {
          fontSize: 14,
          alignment: 'center',
          color: "#ff0000",
        },
        textCenterBoldRed: {
          fontSize: 16,
          alignment: 'center',
          color: "#ff0000",
          bold: true,
        },
        textBold: {
          fontSize: 16,
          bold: true,
        },
        textBoldRight: {
          fontSize: 16,
          bold: true,
          alignment: 'right'
        },
        textBoldCenter: {
          fontSize: 16,
          bold: true,
          alignment: 'center'
        },
      },
      defaultStyle: {
        font: 'THSarabunNew'
      }
    };

    pdfMake.createPdf(docDefinition).open()

  }

  onChangeParkLocation(carSelect, index, event) {

    var car_id = carSelect.car_id
    var park_location = event.target.value
    var car_list = this.state.car_list.map(car => car.car_id === car_id ? {...car, park_location: park_location, car_edit: 2 } : car )

    this.setState({
      car_list: car_list
    });

  }

  onChangePlateRed(carSelect, index, event) {

    var car_id = carSelect.car_id
    var plate_red = event.target.value
    var car_list = this.state.car_list.map(car => car.car_id === car_id ? {...car, plate_red: plate_red, car_edit: 2 } : car )

    this.setState({
      car_list: car_list
    });

  }

  onChangeTunedCar(carSelect, index, event) {

    var car_id = carSelect.car_id
    var tuned_car = event.target.value
    var car_list = this.state.car_list.map(car => car.car_id === car_id ? {...car, tuned_car: tuned_car, car_edit: 2 } : car )

    this.setState({
      car_list: car_list
    });

  }

  onClickSave(carSelect, index,) {
    var car_id = carSelect.car_id
    var plate_red = carSelect.plate_red
    var park_location = carSelect.park_location
    var tuned_car = carSelect.tuned_car

    //update to db
    var data = {
      plate_red: plate_red,
      park_location: park_location,
      tuned_car: tuned_car
    }

    var url = APIURL+'/car/park/'+car_id
    axios.put(url, data).then(res => {
      if(res.status === 200) {
        var car_list = this.state.car_list.map(car => car.car_id === car_id ? {...car, car_edit: 3 } : car )
        this.setState({
          car_list: car_list
        });
      }
    })
      .catch(error => {
        alert("พบข้อผิดพลาด : "+error)
      })

  }


  render() {

     var tbodyList = this.state.car_list.map((car, index) => {
       return (
         <tr key={index}>
           <td className="text-center">{index+1}</td>
           <td>
             <div>{car.car_name} {car.car_color_name}</div>
           </td>
           <td className="text-center">
             {car.car_license_plate_new} <br/> {car.province_name_new}
           </td>
           <td className="text-center">
             <input type="text"
                    className="form-control text-center"
                    id="plate_red"
                    name="plate_red"
                    maxLength={10}
                    value={this.state.car_list[index].plate_red}
                    onChange={(event)=> this.onChangePlateRed(car, index, event)}
             />
           </td>
           <td className="text-center">
             <select
               className="form-control"
               value={this.state.car_list[index].park_location}
               onChange={(event) => this.onChangeParkLocation(car, index, event)}
             >
               {/*<option value="หน้าเต็นท์">หน้าเต็นท์ สาขา 1 </option>*/}
               {/*<option value="หลังเต็นท์">หลังเต็นท์ สาขา 2</option>*/}
               <option value="สาขา 1">สาขา 1</option>
               <option value="สาขา 2">สาขา 2</option>
               <option value="สหการประมูล">สหการประมูล</option>
               <option value="แอพเพิลการประมูล">แอพเพิลการประมูล</option>
               <option value="สากลการประมูล">สากลการประมูล</option>
               <option value="จอดอู่">จอดอู่</option>
               <option value="จอดศูนย์">จอดศูนย์</option>
               <option value="กำลังมา">กำลังมา</option>
             </select>
           </td>
           <td className="text-center">
             <select
               className="form-control"
               value={this.state.car_list[index].tuned_car}
               onChange={(event) => this.onChangeTunedCar(car, index, event)}
             >
               <option value="แต่ง">แต่ง</option>
               <option value="-">-</option>
             </select>
           </td>
           <td className="text-center  ">{ this.state.reserve_status.includes(car.car_status_id)? "จอง" : "-"}</td>
           <td className="text-center">
              <button
                className={car.car_edit === 1 ? "btn btn-sm btn-success" : (car.car_edit === 2) ? "btn btn-sm btn-warning" : "btn btn-sm " }
                disabled={car.car_edit===3}
                onClick={() => this.onClickSave(car, index)}
              >บันทึก</button>
           </td>
         </tr>
       )
     });

     var tbEmpty = (
       <tr><td colSpan={8} className="text-danger text-center">ไม่พบข้อมูลรถ</td></tr>
     )
     var tbBody = this.state.car_list.length===0 ? tbEmpty : tbodyList

     return (
       <div className="card">
         <div className="card-block">
           <div className="row">
             <div className="col-sm-12 col-md-12">
               <div className="card card-accent-info">
                 <div className="card-header">
                   <strong> ข้อมูลรถในเต็นท์ </strong>

                   <button className="btn btn-primary float-right" onClick={this.printCarAll}>
                     <i className="icon-printer"></i>&nbsp; พิมพ์
                   </button>
                 </div>
                 <div className="card-block">
                 <table className="table table-striped">
                   <thead>
                     <tr>
                       <th className="text-center">#</th>
                       <th className="text-center">ยี่ห้อ/รุ่น</th>
                       <th className="text-center">ทะเบียน</th>
                       <th className="text-center" style={{width: 120}}>ป้ายแดง</th>
                       <th className="text-center">รถจอด</th>
                       <th className="text-center" style={{width: 100}}>รถแต่ง</th>
                       <th className="text-center">รถจอง</th>
                       <th className="text-center">จัดการ</th>
                     </tr>
                   </thead>
                   <tbody>
                   {tbBody}
                   </tbody>
                 </table>
                 </div>
               </div>
             </div>
           </div>
         </div>
       </div>
     )
   }
}

export default CarInAll;
